// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kTTWGwTcEjUtpHg9C1oY{cursor:pointer;display:inline-flex}.kTTWGwTcEjUtpHg9C1oY.h0gjIX8ggZYzuoXWiz4Z,.kTTWGwTcEjUtpHg9C1oY.h0gjIX8ggZYzuoXWiz4Z>div{display:grid}.kTTWGwTcEjUtpHg9C1oY>div{display:inline-flex}.kTTWGwTcEjUtpHg9C1oY.mbRwmbu3D4cHWQXUi4kN,.kTTWGwTcEjUtpHg9C1oY.mbRwmbu3D4cHWQXUi4kN>div,.kTTWGwTcEjUtpHg9C1oY.mbRwmbu3D4cHWQXUi4kN>div>div{width:100%}.NjJYaQgfAn0MUwKasPyw{cursor:default}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `kTTWGwTcEjUtpHg9C1oY`,
	"grid": `h0gjIX8ggZYzuoXWiz4Z`,
	"fullWidth": `mbRwmbu3D4cHWQXUi4kN`,
	"withoutPointer": `NjJYaQgfAn0MUwKasPyw`
};
export default ___CSS_LOADER_EXPORT___;
